module.exports = __webpack_public_path__ + "img/videoEmpty.5b026a20.png";